module.exports = __webpack_public_path__ + "static/media/ic_pet2.f38a846b.png";